import { render, staticRenderFns } from "./BsNotificationContent.vue?vue&type=template&id=9b656bf8&scoped=true&"
import script from "./BsNotificationContent.vue?vue&type=script&lang=js&"
export * from "./BsNotificationContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b656bf8",
  null
  
)

export default component.exports